import { render, staticRenderFns } from "./MyAccountProfile.vue?vue&type=template&id=5b81e1aa&"
import script from "./MyAccountProfile.vue?vue&type=script&lang=js&"
export * from "./MyAccountProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports